import React from "react";

import { Alert } from "@mui/material";

export const EmptyTasksAlert: React.FC = () => {
  return <Alert severity="info">There are no tasks to display</Alert>;
};

export const JobErrorAlert: React.FC<{ error: string }> = ({ error }) => {
  return <Alert severity="error">{error}</Alert>;
};
